// extracted by mini-css-extract-plugin
export default {"tokenomics_header":"TokenomicsHeader_tokenomics_header__szK7+"};